module.exports = __webpack_public_path__ + "img/text-bottom.9c4d187d.png";